import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { H5 } from 'syf-component-library/ui/typography';
import query from 'syf-component-library/const/mediaQueries';
import { useEffect } from 'react';
import { Paragraph } from '../../components/Styled/typography';
import { t } from '../../translations/getTranslation';
import ModalImage from '../../components/ModalImage';
import { ReplacementCardOnlineChatButton } from '../../components/Button';
import useConfig from '../../context/config.context';
import useAccountSummary from '../../hooks/useAccountSummary';
const ImageWrapper = styled.div `
  margin: ${spacing.large}px auto;
  display: flex;
  justify-content: center;
`;
const Title = styled(H5) `
  margin: 0 auto;
  text-align: center;
  font-weight: ${fontWeights.bold};
  width: 80%;

  @media ${query.lessThanMedium} {
    font-size: ${fontSizes.root}px;
    width: 100%;
  }
`;
const APIError = () => {
    const { triggerAnalyticsEvent } = useConfig();
    const { isSuccess, isSemu, currentReason } = useAccountSummary();
    useEffect(() => {
        if (!isSuccess) {
            return;
        }
        triggerAnalyticsEvent({
            messageType: isSemu ? 'semu' : 'nonsemu',
            pageFunction: 'replace your card',
            pageSubFunction: (currentReason === null || currentReason === void 0 ? void 0 : currentReason.value)
                ? currentReason.value.replace('-', ' ')
                : '',
            pageKind: 'account services',
            pageName: 'api error',
            errorMessage: 'Please try again later'
        });
    }, [triggerAnalyticsEvent, isSemu, isSuccess, currentReason]);
    return (_jsxs(_Fragment, { children: [_jsx(ImageWrapper, { children: _jsx(ModalImage, { imageName: "API_ERROR" }) }), _jsx(Title, { children: t('errorBoundary.title') }), _jsxs(Paragraph, { children: [t('errorBoundary.pleaseTryAgain'), " ", _jsx(ReplacementCardOnlineChatButton, {}), "."] })] }));
};
export default APIError;
//# sourceMappingURL=index.js.map